import {
  HeaderContent,
  HeaderTitle,
  StyledTable,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './Components.styles';

const Table = ({ columns = [], data = [] }) => {
  return (
    <StyledTable>
      <TableHead>
        <TableRow>
          {columns?.map((col) => (
            <TableHeader key={col.key}>
              <HeaderContent>
                {col.icon && <span>{col.icon}</span>}
                <HeaderTitle>{col.title}</HeaderTitle>
              </HeaderContent>
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
      <tbody>
        {data?.map((item, index) => (
          <TableRow key={index}>
            {columns.map((col) => (
              <TableCell key={col.key}>
                {col.render
                  ? col.render(item[col.dataIndex], item) || '-'
                  : item[col.dataIndex] || '-'}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </tbody>
    </StyledTable>
  );
};

export default Table;
